<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-mb-card">
    <v-col class="com-mb-card-contents py-2">
      <v-row class="px-2">
        <v-btn
          rounded
          depressed
          :outlined="!isRadarType('xrain')"
          x-small
          :disabled="isNotPlay"
          color="success"
          @click="setRadarType('xrain')"
        >
          <span>{{ text.xrain }}</span>
        </v-btn>
        <div class="ml-1 obstime">{{ radarXrainDate }}</div>
      </v-row>
      <v-row class="pt-2 px-2">
        <v-btn
          rounded
          depressed
          :outlined="!isRadarType('cband')"
          x-small
          :disabled="isNotPlay"
          color="success"
          @click="setRadarType('cband')"
        >
          <span>{{ text.cband }}</span>
        </v-btn>
        <div class="ml-1 obstime">{{ radarCbandDate }}</div>
      </v-row>
      <v-row class="pt-2 px-4 flex-row-reverse">
          <a
            :href="xrainNoteUrl"
            target="_self"
            @click="clickXrainNote"
          >{{ text.xrainNote }}</a>
      </v-row>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [mb]レーダ雨量画面 レーダ雨量の種類カード
 * RdType.vue
 * @author LIS
 */
import mixin from "../../lib/mixin.js";
import Util from "./../../lib/util";
import PageLog from "./../../lib/pageLog.js";

export default {
  name: "rd-type",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "レーダ雨量の種類",
        xrain: "　ＸＲＡＩＮ　",
        cband: "Ｃバンドレーダ",
        obstime: "観測日時：",
        featureObsMsg: "最新観測日時より未来が指定されています",
        xrainNote: "レーダ雨量ご利用上の注意事項",
      },
    };
  },
  computed: {
    /** 履歴動画再生/準備中以外状態 */
    isNotPlay: {
      get() {
        return !this.$store.getters["radar/isNotPlay"];
      },
    },
    /** XRAIN観測日時 */
    radarXrainDate: {
      get() {
        let date = this.$store.state.radar.radarXrainDate;
        let newDate = this.$store.state.radar.radarNewXrainDate;
        if (date != null && newDate != null) {
          if (Util.formatDate(newDate) < Util.formatDate(date)) {
            return this.text.featureObsMsg;
          }
          return this.text.obstime + Util.formatDate24(date);
        }
        return "";
      },
    },
    /** Cバンドレーダ観測日時 */
    radarCbandDate: {
      get() {
        let date = this.$store.state.radar.radarCbandDate;
        let newDate = this.$store.state.radar.radarNewCbandDate;
        if (date != null && newDate != null) {
          if (Util.formatDate(newDate) < Util.formatDate(date)) {
            return this.text.featureObsMsg;
          }
          return this.text.obstime + Util.formatDate24(date);
        }
        return "";
      },
    },
    /** 観測日時 [true:最新, false:履歴] */
    isCurrent: {
      get() {
        return this.$store.state.app.isCurrent;
      },
    },
    /** XRAINご利用上の注意事項URL */
    xrainNoteUrl: {
      get() {
        return this.$store.state.app.config.appConfig.linkUrls.xrain;
      },
    },
  },
  methods: {
    /** レーダの種類設定 */
    setRadarType(type) {
      this.$store.commit("radar/resetHistoryPlay");
      this.$store.commit("radar/setType", type);
      this.replaceRadarQueryForMb();
    },
    /** レーダの種類取得 */
    isRadarType(type) {
      let radarType = this.$store.state.radar.radarType;
      return radarType === type;
    },
    /** XRAINのご利用上の注意事項クリック */
    clickXrainNote() {
      // アクセスログ出力
      PageLog.log({
        page_log: "xrain_notes",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
    },
  },
  watch: {
    /** 観測日時 [true:最新, false:履歴] */
    isCurrent() {
      // カレント表示の場合は日時をパラメータから外す
      if (this.isCurrent) {
        this.replaceRadarQueryForMb();
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.obstime {
  font-size: 0.7rem;
}
</style>
